import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS } from 'common/constants';
import { RootState } from 'store';
import {
  CheckSequencingState,
  PrinterAndCheckNoResponseType,
  PrinterErrors
} from './types';

const initialState: CheckSequencingState = {
  checkNoInputError: false,
  printerErrors: {
    printerError: false,
    checkTrayError: false,
    overflowTrayError: false
  },
  printerAndCheckNoResponse: {
    nextCheckNo: '',
    dmsPrinterNo: '',
    cloudPrinterId: '',
    printerId: '',
    isDefaultPrinter: false,
    isAccountingPrinter: true,
    printerDetails: {
      printerName: '',
      checkTray: '',
      overFlowTray: '',
      isMICRPrinter: true
    }
  }
};

export const checkSequencingSlice = createSlice({
  name: REDUX_SLICE_KEYS.checkSequencing,
  initialState,
  reducers: {
    setAllPrinterErrors: (
      state,
      action: PayloadAction<PrinterErrors>
    ): void => {
      state.printerErrors = action.payload;
    },
    setSelectedPrinterResponse: (
      state,
      action: PayloadAction<PrinterAndCheckNoResponseType | undefined>
    ): void => {
      state.printerAndCheckNoResponse = action.payload;
    }
  }
});

export const { setAllPrinterErrors, setSelectedPrinterResponse } =
  checkSequencingSlice.actions;

export const getRootState = (state: RootState): RootState => state;

export const getInitialState = (state: RootState): CheckSequencingState =>
  state.checkSequencing;

export const getSelectedPrinterResponse = createSelector(
  getInitialState,
  ({ printerAndCheckNoResponse }) => printerAndCheckNoResponse
);

export const getIsMICRPrinter = createSelector(
  getSelectedPrinterResponse,
  printerAndCheckNoResponse =>
    printerAndCheckNoResponse?.printerDetails.isMICRPrinter
);

export const getAllPrinterErrors = createSelector(
  getInitialState,
  ({ printerErrors }) => printerErrors
);

export const getPrinterName = createSelector(
  getSelectedPrinterResponse,
  printerAndCheckNoResponse =>
    printerAndCheckNoResponse?.printerDetails.printerName
);

export default checkSequencingSlice.reducer;
